import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { getShortIdForOrder } from '../../../utils/orderUtils';
import { Order } from '@m4a3/api-client';

interface OrderWeightDialogProps {
  order: Order;
  initialValue?: string;
  onCloseButtonPressed: () => void;
  onSubmit: (val: string) => void;
}
const OrderWeightDialog = (props: OrderWeightDialogProps) => {
  const [orderWeight, setOrderWeight] = useState(props.initialValue || '');

  return (
    <div>
      <Dialog 
        open={true} 
        onClose={props.onCloseButtonPressed}
        maxWidth="md"
        fullWidth={true} 
        PaperProps={{
          style: {
            minHeight: '300px', 
          },
        }}
      >
        <DialogTitle style={{ fontSize: '24px', padding: '24px 24px 16px' }}>Enter weight</DialogTitle>
        <DialogContent style={{ padding: '0 24px 20px' }}>
          <DialogContentText style={{ fontSize: '18px', marginBottom: '20px' }}>
            Order {getShortIdForOrder(props.order)}
          </DialogContentText>
          <TextField 
            type='number' 
            placeholder="Order weight" 
            value={orderWeight} 
            onChange={e => setOrderWeight(e.target.value)} 
            autoFocus={true}
            fullWidth
            variant="outlined"
            InputProps={{
              style: { 
                fontSize: '20px',
                padding: '8px',
                height: '56px' 
              }
            }}
          />
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px 24px' }}>
          <Button 
            onClick={props.onCloseButtonPressed}
            size="large"
            style={{ fontSize: '16px' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={() => props.onSubmit(orderWeight)}
            variant="contained"
            size="large"
            style={{ fontSize: '16px' }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default OrderWeightDialog;